class ExtendedDate {

    #date = {};

    constructor(date) {
        if (!(date instanceof Date)) {
            throw new Error("Date is not a date!");
        }

        this.#date = date;
    }

    getDate() {
        return this.#date;
    }

    setHoursAndReturnNewDate(hours) {
        return new ExtendedDate(new Date(this.#date.setHours(hours)));
    }

    setMinutesAndReturnNewDate(minutes) {
        return new ExtendedDate(new Date(this.#date.setMinutes(minutes)));
    }

    setSecondsAndReturnNewDate(seconds) {
        return new ExtendedDate(new Date(this.#date.setSeconds(seconds)));
    }

    setMillisecondsAndReturnNewDate(milliseconds) {
        return new ExtendedDate(new Date(this.#date.setMilliseconds(milliseconds)));
    }

}

export default ExtendedDate;